import { useHasActiveImports } from '@shared/api/hooks/ccf/imports';
import { ImportTypeEnum } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import { Button } from '@shared/components/ui/button';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../../purchased-goods-routes';
import PurchasedPackagingPreviewSheet from './purchased-packaging-preview-sheet';

export default function PurchasedPackagingTableToolbar() {
  const navigate = useNavigate();
  const hasActiveImports = useHasActiveImports(
    ImportTypeEnum.purchased_goods,
    'packaging'
  );

  return (
    <div className="flex items-center gap-6">
      {hasActiveImports && (
        <Link
          to={purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST}
          className="flex items-center gap-1.5 text-sm text-gray-600"
        >
          <Icons.loader2 className="size-4 animate-spin text-teal-500" />
          <span>Items importing</span>
        </Link>
      )}
      <div className="flex items-center gap-2">
        <PurchasedPackagingPreviewSheet />
        <Button
          size="sm"
          onClick={() => {
            navigate(
              generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT),
              {
                state: { from: location.pathname, search: location.search },
              }
            );
          }}
        >
          Add data
        </Button>
      </div>
    </div>
  );
}
